import React, { useState } from "react";
import jsPDF from "jspdf";
import format from "date-fns/format";

import { NO_DATA_FOUND, DOC_ICON } from "../../../../constants";
import {
  parseDateToLocal,
  parseTimeToLocal,
} from "../../../../utils/parseDateTime";

import Modals from "../../../../components/uiElements/popupModal/modal";
import { convertTimeTo12HourFormat } from "../../../../utils/parseDateTime";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import "./index.css";

const PatientPrescriptionsList = ({
  prescriptions,
  searchValue,
  searchPrescriptions,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPrescription, setCurrentPrescription] = useState();

  const fetchedPrescriptions = !searchValue
    ? prescriptions || searchPrescriptions
    : searchPrescriptions || prescriptions;

  console.log(currentPrescription, "currentPrescription");

  const generatePDF = (prescription) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Patient Prescription", 10, 10);

    // Add prescription details
    doc.setFontSize(12);
    doc.text(`Dose Form: ${prescription.DoseForm || " - "}`, 10, 20);
    doc.text(`Prescription Name: ${prescription.DisplayName || " - "}`, 10, 30);
    doc.text(`Strength: ${prescription.Strength || " - "}`, 10, 40);
    doc.text(`Quantity: ${prescription.Quantity || " - "}`, 10, 50);
    doc.text(`Refills: ${prescription.Refills || " - "}`, 10, 60);
    doc.text(`Route: ${prescription.Route || " - "}`, 10, 70);
    doc.text(
      `Prescriber Name: ${
        prescription.PrescriberFirstName
          ? `${prescription.PrescriberFirstName} ${prescription.PrescriberLastName}`
          : " - "
      }`,
      10, 
      80
    );
    doc.text(
      `Written Date: ${
        prescription.WrittenDate
          ? format(parseDateToLocal(prescription.WrittenDate), "MM-dd-yyyy")
          : " - "
      }`,
      10,
      90
    );

    if (prescription.PrescriberSignature) {
      doc.text("Prescriber Signature:", 10, 100);
      doc.addImage(
        prescription.PrescriberSignature,
        "JPEG",
        10,
        110,
        50,
        50
      );
    }

    // Save the PDF
    doc.save(`Prescription_${prescription.DisplayName || "Unknown"}.pdf`);
  };

  return (
    <>
      <Modals
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        onBackdropClick={true}
        onRequestClose={() => setIsOpen(false)}
        styles={{
          content: {
            minWidth: "70%",
            maxWidth: "70%",
            minHeight: "80%",
            maxHeight: "80%",
            overflowY: "scroll",
          },
        }}
        title={"Prescription"}
      >
        {/* Modal content */}
        <div className="patient-prescriptions">
          {/* Prescription details */}
        </div>
      </Modals>
      {fetchedPrescriptions.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <table className="table mt-3">
          <thead>
            <tr>
              <th>Prescription Name</th>
              <th>Date</th>
              <th>Time</th>
              <th>Doctor Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {fetchedPrescriptions.map((prescription) => (
              <tr key={prescription.id}>
                <td
                  onClick={() => {
                    setIsOpen(true);
                    setCurrentPrescription(prescription);
                  }}
                >
                  <img src={DOC_ICON} alt="document_icon" />
                  <span className="ml-2">{prescription?.DisplayName}</span>
                </td>
                <td>{format(parseDateToLocal(prescription?.WrittenDate), "MM-dd-yyyy")}</td>
                <td>
                  {convertTimeTo12HourFormat(
                    parseTimeToLocal(
                      format(parseDateToLocal(prescription?.WrittenDate), "hh:mm a")
                    )
                  )}
                </td>
                <td>
                  {prescription?.PrescriberFirstName
                    ? `${prescription.PrescriberFirstName} ${prescription.PrescriberLastName}`
                    : " - "}
                </td>
                <td>
                  <button
                    onClick={() => generatePDF(prescription)}
                    className="btn btn-primary"
                  >
                    <ProfileIcon type="download" className="px-2" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default PatientPrescriptionsList;
